<template>
	<div>
		<!--左侧导航-->
		<aside class="lyear-layout-sidebar">
		  
		  <!-- logo -->
		  <div id="logo" class="sidebar-header">
		    <a href="index"><img src="../assets/images/logo-sidebar.png" title="LightYear" alt="LightYear" /></a>
		  </div>
		  <div class="lyear-layout-sidebar-scroll"> 
		    
		    <nav class="sidebar-main">
		      <ul class="nav nav-drawer">
		        <li class="nav-item" :class="routePath=='/userIndex'?'active':''"> <router-link to="/userIndex"><i class="mdi mdi-home"></i> 用户首页</router-link> </li>
						<li class="nav-item" v-show="authorStatus==1" :class="routePath=='/userDepot'?'active':''"> <router-link to="/userDepot"><i class="mdi  mdi-palette"></i>我的投稿</router-link> </li>
		        <li class="nav-item" :class="routePath=='/userOrder'?'active':''"> <router-link to="/userOrder"><i class="mdi mdi-format-align-justify"></i>我的订单</router-link> </li>
						<li class="nav-item" :class="routePath=='/userCollect'?'active':''"> <router-link to="/userCollect"><i class="mdi   mdi-palette"></i>我的收藏</router-link> </li>
						<li class="nav-item" v-show="authorStatus==1" :class="routePath=='/userCbt'?'active':''"> <router-link to="/userCbt"><i class="mdi  mdi-file-outline"></i>我要投稿</router-link> </li>
		       </ul>
		    </nav>
		    
		    <div class="sidebar-footer">
		      <p class="copyright">Copyright &copy; 2020. 图片安徽 </p>
		    </div>
		  </div>
		  
		</aside>
		<!--End 左侧导航-->
	</div>
</template>
<script>

export default {
  data () {
    return {
			routePath: '', // 路由值
			authorStatus:0
		}
  },

  created () {
		let _this = this
		_this.routePath = _this.$route.path
	},
	
	mounted () {
		this.checkToken()
	},

  methods: {
		// 验证token的时效性
		async checkToken () {
			// 验证token的时效性
			let _this = this
			const tokenState = await this.util.checkToken(localStorage.getItem('token'))
			_this.authorStatus = tokenState.data.authorStatus
		},
	}
}
</script>

<style lang="less" scoped>

</style>
